// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cms-field-group',
    // #endregion
    // #region Properties
    props: {
        content: {
            type: Object,
            required: true,
            default: {}
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        subTitle: {
            type: String,
            required: false,
            default: ''
        }
    },
    // #endregion
    // #region Methods
    methods: {
        isRowSlow(slot) {
            return slot.type.startsWith("g-row");
        }
    }
    // #endregion
});
// #endregion
